<template>
  <v-dialog
    v-model="dialog"
    content-class="c-upload-dialog"
    :fullscreen="$vuetify.breakpoint.xsAndDown"
    overlay-opacity="0.2"
    scrollable
    transition="scale-transition"
    @click:outside="closeModal"
    @keydown.esc="closeModal"
  >
    <v-card>
      <v-card-text>
        <v-container fluid>
          <v-file-input
            class="pa-2"
            label="File input"
            outlined
            dense
          />

          <FileDropZone />

        </v-container>
      </v-card-text>

      <v-alert
        v-if="message"
        :color="isError ? 'error' : 'success'"
        dark
      >
        {{ message }}
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import FileDropZone from '@/components/base/FileDropZone'

export default {
  name: 'FileUploader',

  components: {
    FileDropZone
  },

  model: {
    prop: 'show',
    event: 'update:show'
  },

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data: function () {
    return {
      dialog: this.show,
      message: '',
      isError: false
    }
  },

  watch: {
    show: {
      immediate: true,
      handler: function (newShow, _oldShow) {
        this.dialog = newShow
      }
    }
  },

  methods: {
    closeModal() {
      this.dialog = false
      this.$emit('update:show', false)
    },

    async onUpload(file, onProgress) {
      console.warn('Uploading...', file, onProgress)
      // api call?
    },

    async upload(formData) {
      console.error('formData', formData)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
